import { create_handoff_drawer } from './onboarding_handoff_base_helpers';
export { create_handoff_drawer };
export {
  create_document_drawer,
  create_obligation_drawer,
  create_renewal_drawer
} from './onboarding_handoff_record_drawers';

export const journey_route_map = {
  Supplier: 'SupplierRegister',
  Employee: 'EmployeeRegister',
  Client: 'ContractLifecycle',
  Partner: 'ContractLifecycle',
  Merchant: 'FinanceCompliance'
};

export const journey_register_map = {
  Supplier: 'supplier compliance register',
  Employee: 'employee compliance register',
  Client: 'contract register',
  Partner: 'partner compliance register',
  Merchant: 'merchant compliance register'
};

export const slugify = (value) => String(value)
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const create_document_row = (
  index,
  entity,
  journey,
  document,
  reference,
  expires,
  status,
  status_class,
  highlighted = false
) => ({
  entity,
  journey,
  document,
  reference,
  expires,
  status,
  status_class,
  highlighted,
  drawer_key: `document_${index}_${slugify(entity)}_${slugify(document)}`
});
